// Plan and seats (ADR 0033, docs/contract.md section 24): the page, seat changes with their
// preview, scheduled changes and statements. Types come from @vd/api-client.

import { queryOptions } from "@tanstack/react-query";
import type { PlanOverview, SeatChange, SeatChangeResult, SeatPreview, StatementView } from "@vd/api-client";
import { api } from "./client";

export const planKeys = {
  plan: ["admin", "plan"] as const,
  statements: ["admin", "billing", "statements"] as const,
};

export const plans = {
  overview: () => api<PlanOverview>("/v1/admin/plan"),
  preview: (userId: string, body: SeatChange) =>
    api<SeatPreview>(`/v1/admin/users/${encodeURIComponent(userId)}/seat/preview`, {
      method: "POST",
      body,
    }),
  setSeat: (userId: string, body: SeatChange) =>
    api<SeatChangeResult>(`/v1/admin/users/${encodeURIComponent(userId)}/seat`, {
      method: "PUT",
      body,
    }),
  cancelChange: (id: string) =>
    api<void>(`/v1/admin/seat-changes/${encodeURIComponent(id)}`, { method: "DELETE" }),
  statements: () => api<{ statements: StatementView[] }>("/v1/admin/billing/statements"),
  exportUrl: (id: string) => `/v1/admin/billing/statements/${encodeURIComponent(id)}/export.csv`,
};

export const planQuery = queryOptions({ queryKey: planKeys.plan, queryFn: plans.overview });
export const statementsQuery = queryOptions({
  queryKey: planKeys.statements,
  queryFn: plans.statements,
});
